"use client";

import Link from "next/link";

import { cn } from "@/utils/lib";
import type { PartialAccount } from "@/utils/types";
import { getUserName } from "@/utils/usernames";

import DesoAvatar from "../shared/deso-avatar";

type TopReferrerProfileAvatarProps = {
  account: PartialAccount;
  className?: string;
  avatarSize?: number;
};

const TopReferrerProfileAvatar = ({
  account,
  className = "",
  avatarSize = 28,
}: TopReferrerProfileAvatarProps) => {
  const content = (
    <>
      <DesoAvatar clickable={false} account={account} size={avatarSize} />

      <span
        className="
          inline-block max-w-[100px] truncate overflow-x-hidden
          underline-offset-4
          group-hover:underline
          md:max-w-full
        "
      >
        {getUserName({
          account,
        })}
      </span>
    </>
  );

  return account.username ? (
    <Link
      href={`/bounty/referrals/${account.username}`}
      onClick={(e) => e.stopPropagation()}
      className={cn(
        `
          flex items-center gap-2 text-xs
          md:text-sm
        `,
        className,
      )}
    >
      {content}
    </Link>
  ) : (
    <div
      className={cn(
        `
          flex items-center gap-2 text-xs
          md:text-sm
        `,
        className,
      )}
    >
      {content}
    </div>
  );
};

export default TopReferrerProfileAvatar;
